import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { assert } from '../../assert';
import { withValidation } from '../../validations';
import type { AriaAttributesSDKProps, AriaValueTextSDK } from './types';

const ariaValueTextSDKFactory: CorvidSDKPropsFactory<
  AriaAttributesSDKProps,
  AriaValueTextSDK
> = ({ setProps, props }) => ({
  get valueText() {
    return props.ariaAttributes?.valueText;
  },
  set valueText(value) {
    setProps({
      ariaAttributes: {
        ...props.ariaAttributes,
        valueText: assert.isNil(value) ? undefined : String(value),
      },
    });
  },
});

export const createAriaValueTextSDK = withValidation(ariaValueTextSDKFactory, {
  type: ['object'],
  properties: {
    valueText: {
      type: ['string'],
      minLength: 1,
      maxLength: 1000,
    },
  },
});
